/**
 * ****************************************************************************
 * @description     :   Route for output
 * @created at      :   2022/06/10
 * @created by      :   ANS774 – kyvd@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ra002000o = () => import('@/views/output/ra002000o');

/**
 * Defined Router
 */
export default [
    {
        path: '/output/ra002000o',
        name: 'ra002000o',
        component: ra002000o,
        meta: {
            title: 'ＱＲコードの発行'
        }
    }
];
